// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"a3d2ad72","443":"b47b64f0","455":"d5689628","566":"d5689628","720":"b47b64f0","788":"ac518b92"}[chunkId] + ".chunk.css";
};